export function rampJsUnitLoaded(container: string, adType: string) {
  return new CustomEvent("rampJsUnitLoaded", {
    detail: { container, adType },
  });
}

export function rampJsAdsLoaded(
  containerName: string,
  adsLoaded: boolean,
  isExperimentVariant: boolean,
  callbackOptions: { termPositions: Record<string, number> },
) {
  return new CustomEvent("adsLoaded", {
    detail: { containerName, adsLoaded, isExperimentVariant, callbackOptions },
  });
}

/**
 * Signals that the Google RSoC path can no longer produce an ad-loaded
 * callback (the CSA `ads.js` script failed to load). Lets the unit gate
 * (rsoc-gate.ts) release injectable units without waiting for its timeout.
 */
export function rampJsRsocFailed(reason: string) {
  return new CustomEvent("rampJsRsocFailed", { detail: { reason } });
}
